/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Tour, TourClass } from '@shared/models';
import { TourStateDefinition } from '@tours/models/tour-state-definition';
import { TourStatesService } from '@tours/services/tour-states.service';

@Component({
    selector: 'app-form-base-data',
    templateUrl: './form-base-data.component.html',
    styleUrls: ['./form-base-data.component.scss'],
    standalone: false
})
export class FormBaseDataComponent implements OnInit {
  readonly today = new Date(new Date().setHours(0, 0, 0, 0));
  @Input() formGroup: UntypedFormGroup;
  @Input() tour: Tour;
  tourClass = TourClass;
  tourStates: TourStateDefinition[];

  constructor(private tourStatesService: TourStatesService) { }

  ngOnInit(): void {
    this.tourStates = this.tourStatesService.getStateDefinitions();
  }

  onTourDateChanged(event: MatDatepickerInputEvent<Date>): void {
    this.formGroup.get('appointment.date').setValue(event.value);
  }
}
